import { useMemo, type ComponentProps } from "react";
import { useWatch } from "react-hook-form";
import { SelectArrayDictField } from "@/components/Form/DictSelectArrayField";
import { useBoundObjectFields } from "./useBoundObjectFields";
import { impliedShape, type SelectorRow } from "./boundShapeSync";

// When the bound object is typed, row names become a select over its
// properties and types lock to them; untyped binds stay free-form. A row whose
// implied type drifts (the source was retyped upstream) is rewritten by the
// editor-level `useBoundConfigSync`, drawer open or not.
export function DictSelectArrayWithBoundShape({
  nodeId,
  suggestionsField,
  ...props
}: ComponentProps<typeof SelectArrayDictField> & {
  nodeId: string;
  suggestionsField: string;
}) {
  const fields = useBoundObjectFields(props.control, nodeId, suggestionsField);
  const rows = useWatch({ control: props.control, name: props.name }) as
    | SelectorRow[]
    | undefined;
  const shape = useMemo(
    () => impliedShape(fields, rows, props.values, props.default_value),
    [fields, rows, props.values, props.default_value]
  );

  return (
    <SelectArrayDictField
      {...props}
      name_values={shape?.names ?? props.name_values}
      name_types={shape?.types}
    />
  );
}
